import { useEffect } from 'react'
import Home from '~/components/Home'
const HomePage = ({
  grsf,
  rs,
}) => {

  useEffect(() => {
    const referralCode = grsf || rs
    if (referralCode) {
      localStorage.setItem('refer', referralCode)
    }
  })

  return <Home />
}

HomePage.getInitialProps = async (req) => {
  return {
    ...req.query,
    routeName: 'home',
    namespacesRequired: ['common']
  }
}

export default HomePage
